import React, { Component } from 'react';
import 'react-dom';
import PropTypes from 'prop-types';
import ResizeObserver from 'resize-observer-polyfill';
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}
function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  }
  return _assertThisInitialized(self);
}
var ResizeObserverComponent = /*#__PURE__*/
function (_Component) {
  _inherits(ResizeObserverComponent, _Component);
  function ResizeObserverComponent(props) {
    var _this;
    _classCallCheck(this, ResizeObserverComponent);
    _this = _possibleConstructorReturn(this, _getPrototypeOf(ResizeObserverComponent).call(this, props));
    _this.state = {
      width: 1,
      height: 1
    };
    _this.ref = React.createRef();
    return _this;
  }
  _createClass(ResizeObserverComponent, [{
    key: "observeIfNeeded",
    value: function observeIfNeeded() {
      var element = this.ref.current;
      if (element && this.element !== element) {
        // clean up after a previous element
        if (this.element) {
          this.unobserve(this.element);
        } // start observing the new element

        this.observe(element);
      }
    }
  }, {
    key: "observe",
    value: function observe(element) {
      var _this2 = this;
      this.resizeObserver = new ResizeObserver(function (entries) {
        // Since we only observe the one element, we don't need to loop over the
        // array
        if (!Array.isArray(entries) || !entries.length) {
          return;
        }
        var entry = entries[0];
        _this2.setState({
          width: entry.contentRect.width,
          height: entry.contentRect.height
        });
      });
      this.resizeObserver.observe(element);
      this.element = element;
    }
  }, {
    key: "unobserve",
    value: function unobserve(element) {
      this.resizeObserver.unobserve(element);
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      this.observeIfNeeded();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.observeIfNeeded();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.ref.current) {
        this.unobserve(this.ref.current);
      }
    }
  }, {
    key: "render",
    value: function render() {
      return this.props.children(this.ref, this.state.width, this.state.height);
    }
  }]);
  return ResizeObserverComponent;
}(Component);
ResizeObserverComponent.propTypes = {
  children: PropTypes.func.isRequired
};
export default ResizeObserverComponent;